import { render, staticRenderFns } from "./ReturnsReport.vue?vue&type=template&id=6b22011e"
import script from "./ReturnsReport.vue?vue&type=script&lang=js"
export * from "./ReturnsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports